const model = {
    submitting: false,
    errors: null,
    statusTypeDetails: null,
    success: false,
};

export default model;